import { createContext, useContext } from 'react';

type CollapseContextType = {
    expanded: string[];
    toggle: (value: string) => void;
    setExpanded: (values: string[]) => void;
};

export const CollapseContext = createContext<CollapseContextType | undefined>(undefined);

export const useCollapse = () => {
    const context = useContext(CollapseContext);
    if (!context) throw new Error('useCollapse must be used within a CollapseProvider');
    return context;  
};